module.exports = __webpack_public_path__ + "img/snb_gjng.b38dc620.svg";